/**
 * Per-route <title> and robots meta for the SPA. Only the home page (style
 * library / landing) is meant for search engines; the editor, detail, admin,
 * compare and embed pages are app screens or user content → noindex.
 */
const SITE = "Vietmap Map Editor";

const ROUTES: { test: RegExp; title: string | null; index: boolean }[] = [
  { test: /^\/(manage)?$/, title: null, index: true },
  { test: /^\/create/, title: "Trình chỉnh sửa", index: false },
  { test: /^\/detail\//, title: "Chi tiết style", index: false },
  { test: /^\/compare/, title: "So sánh style", index: false },
  { test: /^\/admin/, title: "Quản trị", index: false },
  { test: /^\/embed\//, title: "Bản đồ", index: false },
];

function robotsTag(): HTMLMetaElement {
  let tag = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.name = "robots";
    document.head.appendChild(tag);
  }
  return tag;
}

/** `path` is router-relative (no `/map-editor` base). `name` overrides the page title. */
export function applyPageMeta(path: string, name?: string) {
  const route = ROUTES.find((r) => r.test.test(path));
  const title = name || route?.title;
  document.title = title ? `${title} · ${SITE}` : `${SITE} – Tạo và tuỳ chỉnh style bản đồ`;
  robotsTag().content = route?.index ? "index, follow" : "noindex, nofollow";
  // /manage duplicates the home page.
  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical && route?.index) canonical.href = canonical.href.replace(/manage$/, "");
}
